<template>
  <div>
    <!-- TODO:: Place progress bar for fast loading  -->
    <!-- <h1 v-if="false">p.i.m.s Loading ...</h1> -->
    <side-bar/>   
  </div>
</template>

<style>
</style>

<script>
import SideBar from "../components/SideBar"; 
export default {
  components: { 
    SideBar
  },
};
</script>



